import React, { useContext, useState } from 'react';
import { SprawneMiastoContext } from '../../../../components/SprawneMiastoContext';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import api, { retrieveApiErrorCode } from '../../../../utils/api';
import AlertBox from '../../../../components/InformationBox';
import { TextField } from '../../../../components/Form';
import ExpandBox from '../../../../components/ExpandBox';

export default function Email() {
    const Context = useContext(SprawneMiastoContext);
    const { t } = useTranslation();
    const [changeEmail, setChangeEmail] = useState<boolean>(false);
    return (
        <div>
            <ExpandBox
                show={changeEmail}
                header={
                    <div className={'flex flex-col py-4 md:flex-row md:gap-3'}>
                        <div className={'w-full text-slate-600 md:w-1/3'}>
                            {t('translation:MY_ACCOUNT.PROFILE.EMAIL')}
                        </div>

                        <div className={'flex w-full '}>
                            <input
                                disabled={true}
                                className={
                                    'w-full  rounded-none rounded-l border border-r-0 border-gray-300 px-2 py-1 outline-0 focus:border-blue-200 disabled:text-gray-500'
                                }
                                type={'text'}
                                value={Context?.user?.email}
                            />
                            <button
                                onClick={() => setChangeEmail(!changeEmail)}
                                className={
                                    'rounded-r border border-SM-yellow px-2 text-SM-yellow transition-all hover:bg-SM-yellow hover:text-white'
                                }>
                                {t('translation:MY_ACCOUNT.PROFILE.CHANGE')}
                            </button>
                        </div>
                    </div>
                }>
                <Formik
                    initialValues={{
                        password: '',
                        email: '',
                    }}
                    validationSchema={Yup.object().shape({
                        email: Yup.string()
                            .required(t('translation:ERRORS.WEB_VALIDATION.0') as string)
                            .email(t('translation:ERRORS.WEB_VALIDATION.4') as string),
                        password: Yup.string().required(
                            t('translation:ERRORS.WEB_VALIDATION.0') as string,
                        ),
                    })}
                    onSubmit={async (values, formikHelpers) => {
                        const response = await api.patch('/users/me/email', {
                            body: JSON.stringify(values),
                        });
                        if (!response.ok) {
                            const errorCode = await retrieveApiErrorCode(response);
                            if (errorCode === false) return;
                            if (errorCode === 2001)
                                return formikHelpers.setFieldError(
                                    'email',
                                    t('translation:ERRORS.API.2001') as string,
                                );
                            return formikHelpers.setFieldError(
                                'password',
                                t('translation:ERRORS.API.2003') as string,
                            );
                        }
                        await Context?.fetchUser();
                        setChangeEmail(false);
                        formikHelpers.resetForm();
                    }}>
                    {(fProps) => (
                        <Form className={'mb-5 flex md:gap-3'}>
                            <div className={'md:w-1/3'} />
                            <div className={'w-full'}>
                                <AlertBox
                                    text={t(
                                        'translation:MY_ACCOUNT.PROFILE.CHANGE_EMAIL_NOTIFICATION',
                                    )}
                                    className={'mb-2'}
                                />
                                <TextField
                                    placeholder={
                                        t(
                                            'translation:MY_ACCOUNT.PROFILE.PROVIDE_NEW_EMAIL',
                                        ) as string
                                    }
                                    type="text"
                                    formik={fProps}
                                    name={'email'}
                                />
                                <TextField
                                    className={'mt-2'}
                                    placeholder={
                                        t(
                                            'translation:MY_ACCOUNT.PROFILE.PROVIDE_PASSWORD',
                                        ) as string
                                    }
                                    type="password"
                                    formik={fProps}
                                    name={'password'}
                                />

                                <button
                                    type={'submit'}
                                    className={
                                        'btn-filled mt-2 bg-SM-yellow text-white ring-SM-yellow'
                                    }>
                                    {t('translation:MY_ACCOUNT.PROFILE.SUBMIT')}
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </ExpandBox>
        </div>
    );
}
